import Item from "./Item";

function Menu({ menus, onClickItem, logout, navigateTo }) {
  function renderDivider(index) {
    return <hr key={index} className="dropdown-divider bg-light" />;
  }

  const sessionToken = localStorage.getItem("SESSION");
  if (!sessionToken) {
    navigateTo();
  }

  return (
    <ul className="navbar-nav">
      {menus.map((menu, i) => {
        if (!Object.keys(menu).length) return renderDivider(i);
        return (
          <Item
            key={`${i + 1}`}
            menu={menu}
            logout={logout}
            onClick={(e, menuItem) => {
              localStorage.removeItem("currentPage");
              onClickItem(e, menuItem);
            }}
          />
        );
      })}
    </ul>
  );
}

export default Menu;
